// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { RiderFeedbackAreaId } from './RiderFeedbackAreaId'
import {
  RiderFeedbackAreaNavigation,
  RiderFeedbackAreaNavigationIcon,
} from './RiderFeedbackAreaNavigation'
import { RiderFeedbackAreaRoutes } from './RiderFeedbackAreaRoutes'

const LazyRiderFeedbackComponent = lazy(() => import('./RiderFeedbackArea'))

const RiderFeedbackComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyRiderFeedbackComponent />
  </SuspenseLoadingWrapper>
)

export const RiderFeedbackArea = {
  id: RiderFeedbackAreaId,
  requiredRight: BoumRight.AREA_RIDER_FEEDBACK,
  Icon: RiderFeedbackAreaNavigationIcon,
  NavigationComponent: RiderFeedbackAreaNavigation,
  route: {
    path: RiderFeedbackAreaRoutes.route,
    component: RiderFeedbackComponent,
  },
}
